import _ from 'lodash';

const EMPTY_ERRORS = [];

export const getErrors = state => _.get(state, 'errors', EMPTY_ERRORS);

export const isErrored = state => !_.isEmpty(getErrors(state));
